import { render } from "./HeroPageNotFound.vue?vue&type=template&id=5fa0efac&scoped=true&ts=true"
import script from "./HeroPageNotFound.ts?vue&type=script&lang=ts"
export * from "./HeroPageNotFound.ts?vue&type=script&lang=ts"

import "./HeroPageNotFound.scss?vue&type=style&index=0&id=5fa0efac&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa0efac"]])

export default __exports__